<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { welfareConfig as rocnovelConfig } from '../../configs/rocnovel'
import { welfareConfig as ocereadConfig } from '../../configs/oceread'
import { welfareConfig as ficmoonConfig } from '../../configs/ficmoon'
import { welfareConfig as novelarcConfig } from '../../configs/novelarc'
import { welfareConfig as storyellaConfig } from '../../configs/storyella'
import { welfareConfig as aurenovelConfig } from '../../configs/aurenovel'
import { welfareConfig as florastoryConfig } from '../../configs/florastory'
import { welfareConfig as silktaleConfig } from '../../configs/silktale'
import { welfareConfig as pearlaConfig } from '../../configs/pearla'
import { welfareConfig as fictoraConfig } from '../../configs/fictora'
import { welfareConfig as marinovelConfig } from '../../configs/marinovel'
import { welfareConfig as flipnovelConfig } from '../../configs/flipnovel'
import { welfareConfig as moonpageConfig } from '../../configs/moonpage'
import { welfareConfig as noveluneConfig } from '../../configs/novelune'
import { welfareConfig as storlynConfig } from '../../configs/storlyn'
import { welfareConfig as novelmelloConfig } from '../../configs/novelmello'
import { isAndroid } from '@/constants'
import { isChrome, isEdge, isSafari } from '@/utils/bowserEnv'
import { loadBrandConfig } from '@/utils/loadBrandConfig'

import addIcon1 from '@/assets/add-icon.webp'
import addIcon2 from '@/assets/add-icon2.webp'
import shareIcon1 from '@/assets/share-icon.webp'
import shareIcon2 from '@/assets/share-icon2.webp'

const props = withDefaults(defineProps<{
  value: boolean
}>(), {
  value: false,
})

const emit = defineEmits<{
  (event: 'input', value: boolean): void
}>()

// 加载当前品牌的 welfare 配置
const config = loadBrandConfig({
  rocnovel: rocnovelConfig,
  oceread: ocereadConfig,
  ficmoon: ficmoonConfig,
  novelarc: novelarcConfig,
  storyella: storyellaConfig,
  aurenovel: aurenovelConfig,
  florastory: florastoryConfig,
  silktale: silktaleConfig,
  pearla: pearlaConfig,
  fictora: fictoraConfig,
  marinovel: marinovelConfig,
  flipnovel: flipnovelConfig,
  moonpage: moonpageConfig,
  novelune: noveluneConfig,
  storlyn: storlynConfig,
  novelmello: novelmelloConfig,
})

const show = ref(false)
const type = computed(() => {
  if (isEdge())
    return 'edge'
  if (isChrome())
    return 'chrome'
  if (isSafari())
    return 'safari'
  return ''
})

watch(
  () => props.value,
  () => {
    show.value = props.value
  },
)
watch(
  () => show.value,
  (value) => {
    emit('input', value)
  },
)
</script>

<template>
  <BasicModal v-model="show" transparent :closable="false">
    <div v-if="type === 'edge'" class="text-white w-full h-screen flex flex-col justify-center items-center text-18px font-medium" @click="show = false">
      <div class="flex items-center">
        1、 {{ config.texts.guideAddStep1 }}
        <img width="38px" height="38px" class="mx-2" src="@/assets/more-icon.webp">
        {{ config.texts.guideAddAtBottomRight }}
      </div>
      <div class="flex items-center my-40px">
        2、 {{ config.texts.guideAddShare }}
        <img width="38px" height="38px" class="mx-2" src="@/assets/share-icon.webp">
      </div>
      <div class="flex items-center">
        3、 {{ config.texts.guideAddToScreen }}
        <img width="38px" height="38px" class="mx-2" src="@/assets/add-icon.webp">
      </div>
    </div>

    <div v-else class="text-white w-full h-screen flex flex-col justify-center items-center text-18px font-medium" @click="show = false">
      <div class="flex items-center">
        1、 {{ config.texts.guideAddStep1 }}
        <img width="38px" height="38px" class="mx-2" :src="isAndroid ? shareIcon2 : shareIcon1">
        {{ type === 'chrome' ? config.texts.guideAddAtTopRight : config.texts.guideAddAtBottom }}
      </div>
      <div class="flex items-center mt-40px">
        2、 {{ config.texts.guideAddToScreen }}
        <img width="38px" height="38px" class="mx-2" :src="isAndroid ? addIcon2 : addIcon1">
      </div>
    </div>
  </BasicModal>
</template>
